import { FC } from 'react'
import LogTime from './LogTime'
import TimeCard from './TimeCard'
import { DateTime } from 'luxon'
import { isLeave } from '@utils/absence'
import { TimeCardsContextTimeCard } from '@features/time-logging/providers/TimeCardsContextProvider'

interface Props {
  timeCard: TimeCardsContextTimeCard
  readOnly: boolean
}

export const Day: FC<Props> = ({ timeCard, readOnly }) => {
  // Time Cards cannot be created when in read-only mode,
  // cannot be created in the future,
  // cannot be created on days where the employee
  // is scheduled to work and has taken time off for the full day
  // or they are on leave (regardless of if they are scheduled to work),
  // and cannot be created on days that are fully locked
  const canCreateTimeCard =
    !readOnly &&
    timeCard.date <= DateTime.now() &&
    (timeCard.scheduledWorkHours === undefined ||
      timeCard.totalTimeOff < (timeCard.scheduledWorkHoursInSeconds ?? 0)) &&
    !timeCard.absences.some(isLeave) &&
    timeCard.lock?.type !== 'full'

  if (timeCard.id !== 0)
    return <TimeCard timeCard={timeCard} className="grow" />
  if (canCreateTimeCard)
    return <LogTime date={timeCard.date} className="grow" />

  return null
}
